<template>
  <!-- 我的申报记录页面 -->
  <div class="applyRecord">
    <el-form ref="form" :model="form" label-width="75px">
      <el-row>
        <el-col :span="8">
          <el-form-item label="政策年份:">
            <el-date-picker
              v-model="form.year"
              type="year"
              value-format="yyyy"
              placeholder="请选择年份"
              @change="query"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="项目政策:">
            <el-select v-model="form.policyUuid" placeholder="请选择" clearable @change="query">
              <el-option
                v-for="item in policyList"
                :key="item.uuid"
                :label="item.policyName"
                :value="item.uuid"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="项目名称:" class="mr0">
            <el-input
              v-model="form.projectName"
              placeholder="请输入"
              @keyup.native.enter="query"
              clearable
            >
              <i
                slot="suffix"
                style="cursor:pointer"
                class="el-input__icon el-icon-search"
                @click="query"
              ></i>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="申报时间:">
            <el-date-picker
              v-model="form.createDate"
              type="date"
              value-format="yyyy-MM-dd"
              @change="query"
              placeholder="请选择"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="审核时间:">
            <el-date-picker
              v-model="form.auditDate"
              type="date"
              value-format="yyyy-MM-dd"
              @change="query"
              placeholder="请选择"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="审核状态:">
            <el-select v-model="form.status" placeholder="请选择" @change="query" clearable>
              <el-option
                v-for="item in typeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="2" style="text-align:right">
          <el-button type="primary" @click="reset">重置</el-button>
        </el-col>
      </el-row>
    </el-form>
    <commonTable
      :headList="headList"
      :dataList="dataList"
      :buttonList="buttonList"
      @check="check"
      :background="true"
      @currentChange="currentChange"
      :total="total"
      :currentPage="currentPage"
      :btnWidth="120"
    />
  </div>
</template>

<script>
import { getListParam, getProList } from "../../utils/interface";
import commonTable from "../../components/commonTable.vue";
export default {
  name: "",
  components: { commonTable },
  props: {},
  data() {
    return {
      form: {
        year: "", // 项目政策年份
        policyUuid: "", // 政策id
        projectName: "", // 项目名称
        createDate: "", // 申报时间
        auditDate: "", // 审核时间
        status: "" // 审核状态
      },
      policyList: [], // 政策
      typeList: [
        { label: "全部", value: "" },
        { label: "待提交", value: "INIT" },
        { label: "审核中", value: "REVIEW" },
        { label: "审核通过", value: "REVIEW_PASS" },
        { label: "审核不通过", value: "REJECT" }
      ], // 审核状态
      headList: [
        { label: "项目政策", value: "policyName", width: 400 },
        { label: "项目名称", value: "projectName" },
        { label: "申报时间", value: "createDate" },
        { label: "审核状态", value: "status", type: "verify" },
        { label: "审核时间", value: "auditDate" }
      ],
      dataList: [],
      buttonList: [
        { name: "查看", type: "applyCheck" },
        { name: "修改", type: "applyEdit" }
      ],
      total: 0,
      currentPage: 1
    };
  },
  watch: {},
  computed: {},
  created() {},
  mounted() {
    this.getProList();
    this.query();
  },
  methods: {
    /* 查询申请记录 */
    query() {
      getListParam({
        current: this.currentPage,
        pageSize: "10",
        userUuid: this.$store.state.isUsermessage.uuid,
        ...this.form
      }).then(res => {
        if (res && res.list.length > 0) {
          this.dataList = res.list;
          this.total = res.total;
        } else {
          this.dataList = [];
          this.total = 0;
        }
      });
    },
    /* 查看详情 */
    check(item) {
      // console.log(item)
      let router = this.$router.resolve({
        path: "./projectReport",
        query: {
          projectId: item.projectId,
          status: item.status,
          policyUuid: item.policyUuid
        }
      });
      window.open(router.href, "_blank");
    },
    /* 获取政策 */
    getProList() {
      getProList({ state: "1" }).then(res => {
        if (res && res.length > 0) {
          this.policyList = res;
        } else {
          this.policyList = [];
        }
      });
    },
    queryProList() {},
    currentChange(Page) {
      this.currentPage = Page.currentPage;
      this.query();
    },
    reset() {
      this.form = {
        year: "", // 项目政策年份
        policyUuid: "", // 政策id
        projectName: "", // 项目名称
        createDate: "", // 申报时间
        auditDate: "", // 审核时间
        status: "" // 审核状态
      };
      this.query();
    }
  }
};
</script>
<style lang="less" scoped>
.applyRecord {
  /deep/ .el-row {
    margin-bottom: 20px;
  }

  /deep/ .el-form-item__label {
    padding-right: 15px;
  }

  /deep/ .el-form-item__content {
    margin-right: 20px;
  }

  .mr0 {
    /deep/ .el-form-item__content {
      margin-right: 0;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/projectApply/applyRecord.vue